import { useSelector } from 'react-redux'
import React from 'react'
import { StateType } from 'tennders-common/types/StateType'
import GLoading from 'tennders-market/common/components/element/GLoading'

const GeneralLayoutLoading = () => {
  const isLoading = useSelector((state : StateType) => state.view.isLoading)

  return (isLoading) ? (
    <div className="tennders-loading full">
      <GLoading size={52} />
    </div>
  ) : null
}

GeneralLayoutLoading.displayName = 'GeneralLayoutLoading'

export default React.memo(GeneralLayoutLoading)
